import axios from 'axios';

export const storeConsumableApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/store-consumable`,
    headers: {
        'Content-Type': 'application/json'
    }
})